export default function PhoneOnline({ online }) {
    return (
        <i className="fas fa-phone" style={{ color: online ? '#444' : '#bbb', fontSize: 16 }}></i>
    );
}